import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = { class: "form-group col-md-6 col-xxl-4" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "text-muted mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonalForm = _resolveComponent("PersonalForm")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_NewPasswordForm = _resolveComponent("NewPasswordForm")!
  const _component_CompanyForm = _resolveComponent("CompanyForm")!
  const _component_RelatedContactTable = _resolveComponent("RelatedContactTable")!
  const _component_AddressForm = _resolveComponent("AddressForm")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.vm.pageTitle)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.vm.pageTitle), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_TabView, {
      activeIndex: _ctx.activeIndex,
      "onUpdate:activeIndex": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeIndex) = $event)),
      onTabChange: _ctx.onTabChange
    }, {
      default: _withCtx(() => [
        (_ctx.shouldShowTab(_ctx.enumTabs.PERSONAL))
          ? (_openBlock(), _createBlock(_component_TabPanel, {
              key: _ctx.enumTabs.PERSONAL,
              header: _ctx.$t('myCadac.accountSettings.tabView.headerPersonal')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PersonalForm, {
                  modelValue: _ctx.personalFormModel,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personalFormModel) = $event)),
                  ref: "personalForm"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Button, {
                  class: "p-button-success p-button-raised p-button-lg",
                  disabled: !_ctx.canSubmit,
                  label: _ctx.$t('common.save'),
                  loading: _ctx.isLoading,
                  onClick: _ctx.onSubmitClick
                }, null, 8, ["disabled", "label", "loading", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.shouldShowTab(_ctx.enumTabs.PASSWORD))
          ? (_openBlock(), _createBlock(_component_TabPanel, {
              key: _ctx.enumTabs.PASSWORD,
              header: _ctx.$t('myCadac.accountSettings.tabView.headerLogin')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("myCadac.accountSettings.lblEmail")), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.vm.login.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.login.email) = $event)),
                        class: "mr-1 p-disabled",
                        readonly: "true",
                        type: "email"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_PopoverIcon, { class: "d-inline-flex" }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", {
                            innerHTML: _ctx.$t('myCadac.accountSettings.changeEmailHelpText')
                          }, null, 8, _hoisted_6)
                        ]),
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createVNode(_component_NewPasswordForm, {
                  modelValue: _ctx.passwordFormModel,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordFormModel) = $event)),
                  ref: "passwordForm"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_Button, {
                  class: "p-button-success p-button-raised p-button-lg",
                  disabled: !_ctx.canSubmit,
                  label: _ctx.$t('common.save'),
                  loading: _ctx.isLoading,
                  onClick: _ctx.onSubmitClick
                }, null, 8, ["disabled", "label", "loading", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.shouldShowTab(_ctx.enumTabs.COMPANY))
          ? (_openBlock(), _createBlock(_component_TabPanel, {
              key: _ctx.enumTabs.COMPANY,
              header: _ctx.$t('myCadac.accountSettings.tabView.headerOrganisation')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CompanyForm, {
                  modelValue: _ctx.companyFormModel,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyFormModel) = $event)),
                  ref: "companyForm",
                  countries: _ctx.vm.countries,
                  "use-vat": ""
                }, null, 8, ["modelValue", "countries"]),
                _createVNode(_component_Button, {
                  class: "p-button-success p-button-raised p-button-lg",
                  disabled: !_ctx.canSubmit,
                  label: _ctx.$t('common.save'),
                  loading: _ctx.isLoading,
                  onClick: _ctx.onSubmitClick
                }, null, 8, ["disabled", "label", "loading", "onClick"]),
                _createVNode(_component_RelatedContactTable, {
                  items: _ctx.vm.relatedContacts
                }, null, 8, ["items"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.shouldShowTab(_ctx.enumTabs.INVOICEADDRESS))
          ? (_openBlock(), _createBlock(_component_TabPanel, {
              key: _ctx.enumTabs.INVOICEADDRESS,
              header: _ctx.$t('myCadac.accountSettings.tabView.headerInvoice')
            }, {
              default: _withCtx(() => [
                (_ctx.vm.invoiceDebtorAccountNumber)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("myCadac.accountSettings.lblinvoiceDebtor", {
						name: _ctx.vm.invoiceDebtorName,
						accountNumber: _ctx.vm.invoiceDebtorAccountNumber,
					})), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_AddressForm, {
                  modelValue: _ctx.invoiceAddressFormModel,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.invoiceAddressFormModel) = $event)),
                  ref: "invoiceAddressForm",
                  countries: _ctx.vm.countries
                }, null, 8, ["modelValue", "countries"]),
                _createVNode(_component_Button, {
                  class: "p-button-success p-button-raised p-button-lg",
                  disabled: !_ctx.canSubmit,
                  label: _ctx.$t('common.save'),
                  loading: _ctx.isLoading,
                  onClick: _ctx.onSubmitClick
                }, null, 8, ["disabled", "label", "loading", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["activeIndex", "onTabChange"])
  ], 64))
}